// Add observers to detect when menu items should be closed and scroll back into view (mobile only)
document.addEventListener("DOMContentLoaded", function() {
  const navbarDiv = document.querySelector("#header .navbar-collapse");
  const subMenuItems = document.querySelectorAll("#header .nav-item.dropdown");

  subMenuItems.forEach(item => {
    const cb = function(mutationsList, observer) {
      const isMobileMenuOpen =
        window.innerWidth < 992 && navbarDiv.classList.contains("show");
      for (const mutation of mutationsList) {
        if (
          isMobileMenuOpen &&
          mutation.type === "attributes" &&
          !mutation.target.classList.contains("show")
        ) {
          mutation.target.scrollIntoView({
            behavior: "instant",
            block: "nearest"
          });
        }
      }
    };

    const observer = new window.MutationObserver(cb);

    observer.observe(item, { attributes: true, attributeFilter: ["class"] });
  });
});
